import styled from 'styled-components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { PRODUCT_CODES } from '_constants/products';
import { refreshActiveProductCode } from '_redux/products/slice';

import BlogGallerySection from '_components/composed/sections/BlogGallerySection';

const StyledBlogGalleryPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BlogGalleryPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(refreshActiveProductCode(PRODUCT_CODES.incLLC));
  }, [dispatch]);

  return (
    <StyledBlogGalleryPage>
      <BlogGallerySection />
    </StyledBlogGalleryPage>
  );
};

export default BlogGalleryPage;
